/*
 * Module-level handle to the live OktaAuth instance created in SecurityProvider.
 *
 * Tokens are kept in memory only (tokenManager storage: 'memory'), so they are
 * no longer readable from localStorage. Non-React modules (the axios interceptor,
 * OpenWindowService) reach the access token through these helpers instead of
 * parsing the old `okta-token-storage` localStorage key.
 */
let instance = null;

export const setOktaAuthInstance = (oktaAuth) => {
  instance = oktaAuth;
};

export const getOktaAuthInstance = () => instance;

// Access token JWT string from the in-memory tokenManager (null if not signed in).
export const getAccessToken = () => instance?.getAccessToken() ?? null;

// Cached access-token claims, read synchronously (null if not signed in).
export const getAccessTokenClaims = () => instance?.tokenManager?.getTokensSync?.()?.accessToken?.claims ?? null;
